import { render, staticRenderFns } from "./PassageReasons.vue?vue&type=template&id=6aab2872"
import script from "./PassageReasons.vue?vue&type=script&lang=js"
export * from "./PassageReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports